
侧边导航
<template>
    <el-menu
    router
    :default-active="currentIndex" 
    :default-openeds="defaultOpeneds"
    class="menu-style"
    background-color="#333"
    text-color="#fff"
    active-text-color="#ffd04b"
    >   
        <template v-for="item in menu">
            <template v-if="item.menuItems">
                <el-submenu :index="item.url" :key="item.url">
                    <template slot="title">{{ item.title }}</template>
                    <el-menu-item 
                    v-for="me in item.menuItems" 
                    :key="me.url"
                    :index="me.url"
                    >
                    <i :class="me.icon" ></i>
                    {{ me.title }}</el-menu-item>
                </el-submenu>
            </template>
            <template v-else>
                <el-menu-item 
                :index="item.url"
                :key="item.url"
                >
                <i :class="me.icon" ></i>
                {{ item.title }}</el-menu-item>
            </template>
        </template>
    </el-menu>
</template>

<script>
export default {
    data(){
        return {
            defaultOpeneds: ['1','2'],
            menu: [
                {
                    url: '1',
                    title: '百博官网',
                    menuItems: [
                        {
                            url: '/index/editingArticles',
                            title: '新建文章',
                            icon: 'el-icon-edit'
                        },
                        {
                            url: '/index/completed',
                            title: '已发文章',
                            icon: 'el-icon-menu'
                        },
                        {
                            url: '/index/consultInformation',
                            title: '处理咨询信息',
                            icon: 'el-icon-document'
                        },
                    ]
                },
                {
                    url: '2',
                    title: '图零官网',
                    menuItems: [
                        {
                            url: '/zero/subNews',
                            title: '新建文章',
                            icon: 'el-icon-edit'
                        },
                        {
                            url: '/zero/newsList',
                            title: '已发文章',
                            icon: 'el-icon-menu'
                        },
                        {
                            url: '/zero/tagsList',
                            title: '标签管理',
                            icon: 'el-icon-grape'
                        },
                        {
                            url: '/zero/info',
                            title: '咨询信息',
                            icon: 'el-icon-cold-drink'
                        },
                    ]
                },
            ]
        }
    },
    computed: {
        currentIndex() {
            return this.$route.path;
        }
    },
    methods: {
    },
}
</script>

<style scoped>
   
</style>